<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12">
    <b-row class="justify-content-center marginalbotsm">
        <b-col cols="auto">
            <b-button @click="activePlugin = 'noDRM'" :variant="(activePlugin === 'noDRM') ? 'greenw':'msstreamblue'">{{$ml.get('examplenodrm')}}</b-button>
            &nbsp;
            <b-button @click="activePlugin = 'withDRM'" :variant="(activePlugin !== 'noDRM') ? 'greenw':'msstreamblue'" >{{$ml.get('exampledrm')}}</b-button>
        </b-col>
    </b-row>
    <b-row class="mt-2">
    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Video.js and integrating **QUANTEEC** without DRM.
``` html
&lt;head>
    &lt;link href="https://vjs.zencdn.net/7.18.1/video-js.css" rel="stylesheet" />

    &lt;script src="https://vjs.zencdn.net/7.18.1/video.min.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;video id="videoplayer" class="video-js vjs-default-skin" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.m3u8";
            
            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{ streamKey }}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };
            
            // 3-Link QUANTEEC configuration to videojs object *before* the creation of the videojs player instance
            var vjsObject = {
                html5: { 
                    quanteec: configQuanteec
                }
            }

            // 4-Register the Quanteec plugin in videojs
            quanteecSourceHandler.register();

            var player = videojs('videoplayer', vjsObject);

            player.src([
                {
                    src: videoSource,
                    type: 'application/x-mpegurl'
                }
            ])     


            player.ready(function () {
                player.play();
            })
            
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>    
    
    <vue-markdown :show="activePlugin === 'withDRM'" style="overflow: auto;" class="col-7" :style="(activePlugin === 'noDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Video.js and integrating **QUANTEEC** with DRM. The documentation of how DRMs work with videoJS player can be found [here](https://github.com/videojs/videojs-contrib-eme).
``` html
&lt;head>
    &lt;link href="https://vjs.zencdn.net/7.18.1/video-js.css" rel="stylesheet" />

    &lt;script src="https://vjs.zencdn.net/7.18.1/video.min.js">&lt;/script>
    &lt;script src="./videojs-contrib-eme.min.js">&lt;/script> &lt;!-- script for DRMs-->
    &lt;script src="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;video id="videoplayer" class="video-js vjs-default-skin" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.m3u8";
            
            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{ streamKey }}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };
            
            // 3-Link QUANTEEC configuration to videojs object *before* the creation of the videojs player instance
            var vjsObject = {
                html5: { 
                    quanteec: configQuanteec
                }
            }

            // 4-Register the Quanteec plugin in videojs
            quanteecSourceHandler.register();

            var player = videojs('videoplayer', vjsObject);

            player.src([
                {
                    src: videoSource,
                    type: 'application/x-mpegurl',
                    // DRM part
                    keySystems: {                                
                        "com.widevine.alpha": {
                            url : "URL_TO_LICENSE_SERVER",
                            audioContentType: 'AUDIO_CONTENT_TYPE',
                            videoContentType: 'VIDEO_CONTENT_TYPE',
                        },
                        "com.microsoft.playready": {
                            url : "URL_TO_LICENSE_SERVER",
                            audioContentType: 'AUDIO_CONTENT_TYPE',
                            videoContentType: 'VIDEO_CONTENT_TYPE',
                        },
                         "com.apple.fps.1_0": {
                            certificateUri: 'CERTIFICATE_URL',
                            licenseUri: 'LICENSE_URL'
                        },
                    // End DRM part    
                }
            ])     


            player.ready(function () {
                player.play();
            })
            
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>

    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
   
</b-row>
</b-col>
</b-row>
</b-container>

</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'Videojs',
  data: function() {
    return {
     activePlugin:"noDRM",
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDoc
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.center {
    display: table;
    margin-left: auto;
    margin-right: auto;
    list-style-position: inside;
}

</style>